import PropTypes from 'prop-types';
import styled from 'styled-components';
import React, { Component } from 'react';


class QuizButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            buttonColors: props.buttonColors,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ selected: nextProps.selected });
    }

    componentWillMount() {
        this.setState({ in: true });
    }

    componentDidMount() {
        this.timeout = setTimeout(() => this.setState({ in: false }), 1000);
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
        this.timeout = null;
    }

    getAnwserState() {
        if(this.props.showCorrectAnswer && this.props.answer.correct === true){
            return 'right';
        }

        if (!this.state.selected) return null;
        return this.props.answer.correct ? 'right' : 'wrong';
    }


    backgroundGradientString() {

        const buttonColors = this.state.buttonColors;
        const answerState = this.getAnwserState();

        if (!answerState) {
            return buttonColors.normal[0];
        }

        const colors = buttonColors[answerState];
        return `linear-gradient(to right, ${colors[0]}, ${colors[1]})`;
    }


    render() {
        const answerIndex = this.props.answerIndex;
        const className = [
            'answerButton',
            this.state.selected ? ' selected' : null,
            this.props.className,
            this.getAnwserState(),
            this.state.in ? 'in' : null,
        ]
        .filter(Boolean)
        .join(' ');

        return (
            <button
              className={className}
              onClick={() => { this.props.onClick(this.props.answer); }}
              style={{
                  background: this.backgroundGradientString(),
              }}
              id={typeof answerIndex === 'number' ? `answer-${answerIndex + 1}` : null}
            >
                {this.props.answer.text}
            </button>
        );
    }
}

// Validate all props that are used inside the component to warn early if they're not supplied
// correctly
QuizButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    answer: PropTypes.shape({
        text: PropTypes.string.isRequired,
        correct: PropTypes.bool.isRequired,
    }),
    buttonColors: PropTypes.shape({
        normal: PropTypes.array.isRequired,
        right: PropTypes.array.isRequired,
        wrong: PropTypes.array.isRequired,
    }),
    answerIndex: PropTypes.number,
};

export default styled(QuizButton)`
    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }

        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }

    @keyframes popIn {
        0% {
            opacity: 0;
            transform: scale3d(0.6, 0.6, 1);
        }
        100% {
            opacity: 1;
            transform: scale3d(1, 1, 1);
        }
    }

    @keyframes zoomin {
        0% {
            transform: scale3d(1, 1, 1);
        }
        100% {
            transform: scale3d(1.3, 1.3, 1.3) rotateZ(-4deg);
        }
    }

    opacity: 0;

    &.in {
        animation: popIn 300ms ${props => props.answerIndex * 100 + 300}ms cubic-bezier(0.5, -0.5, 0.5, 1.5);
        animation-fill-mode: backwards;
    }

    cursor: default;
    box-sizing: border-box;
    border: none;
    outline: none;
    font-size: inherit;
    cursor: pointer;
    color: white;
    text-align: center;

    transform: translate3d(0, 0, 0);

    &.wrong {
        animation: shake 0.2s cubic-bezier(.36,.07,.19,.97) both;
    }

    &.right {
        animation: zoomin 0.15s ease-out forwards;
        z-index: 1000;
    }
`;



// WEBPACK FOOTER //
// ./src/campaign/challenges/quiz/quiz-button.jsx